import Vue from "vue";
// import VueMoment from "vue-moment";
import moment from "moment-timezone";
Vue.filter("formatDate2Cliente", function(value) {
  var date = moment.tz(value, "America/Argentina/Buenos_Aires");
  var formateado = date.locale("es").format("LLLL");
  return formateado.charAt(0).toUpperCase() + formateado.slice(1);
});
Vue.filter("formatDMY", function(value) {
  var date = moment.tz(value, "America/Argentina/Buenos_Aires");
  var formateado = date.locale("es").format("DD-MM-YYYY");
  return formateado.charAt(0).toUpperCase() + formateado.slice(1);
});
Vue.filter("toInteger", function(value) {
  return parseInt(value);
});
// TRUNCA EL TEXTO SEGUN EL MAXIMO DE CARACTERES PASADO COMO PARAMETRO Y DEVULVE 3 PUNTOS SUSPENSIVOS AL FINAL
Vue.filter("truncateString", function(value, maxCaracteres) {
  if (value.length <= maxCaracteres) {
    return value;
  }
  const truncado = value.substring(0, maxCaracteres - 3);
  return `${truncado}...`;
});
